import React, { Component } from "react";
import { getStaticText } from '../../../lables/lablesService';
import HtmlInput from '../../../components/html-input-component/htmlInput';
import VacancyCategories from '../api/vacancyCategories';


class CategoryForm extends Component {


    constructor(props){
        super(props);

        this.save_type_process = false;
    }


    changeInfoValue ( prop_name, prop_value ) {
    	let value = null;
        switch (prop_name) {
            case 'description':
                    value = prop_value;
                break;

            case 'active':
                    value = prop_value.target.checked ? 1 : 0;
                break;

            default:
                    value = prop_value.target.value
                break;
        }
        this.props.info[prop_name] = value;
    }


    async savePost () {
    	if ( this.save_type_process )
            return false;

        this.save_type_process = true;
        const formData = new FormData();

        if ( this.props.info.id > 0 )
            formData.append( 'id', this.props.info.id );

        formData.append( 'name', this.props.info.name );
        formData.append( 'description', this.props.info.description );
        formData.append( 'active', this.props.info.active );
        
        var data = {};
        formData.forEach((value, key) => data[key] = value);

        let result = null;
        if ( this.props.info.id === 0 )
            result = await VacancyCategories.add( data );
        else
            result = await VacancyCategories.update( data );
    
        if ( !result ) {
            window.alert( getStaticText('save_error') );
        } else {
            window.alert( getStaticText('save_success') );
            if ( typeof(this.props.formCallback) === 'function' )
            	this.props.formCallback();
        }

        this.save_type_process = false;
    }


	render () {
		return (<>

                <div className="form-group">
                    <label
                        htmlFor="vcNameInput"
                    >
                        {getStaticText('vc_form_title_input_label')}
                    </label>
                    <input 
                        id="vcNameInput"
                        className="form-control"
                        defaultValue={this.props.info.name}
                        onChange={this.changeInfoValue.bind(this, 'name')}
                    />
                </div>

                <HtmlInput 
                    label={getStaticText('vc_form_description_input_label')}
                    content={this.props.info.description}
                    inputName="description"
                    onChangeContent={this.changeInfoValue.bind(this)}
                />

                <div className="form-group">
                    <label>
                        <input 
                            type="checkbox"
                            defaultChecked={this.props.info.active}
                            onChange={this.changeInfoValue.bind(this, 'active')}
                        /> {getStaticText('vc_form_active_input_label')}
                    </label>
                </div>

                <div className="form-group os-text-right">
                    <button
                        className="btn btn-success"
                        onClick={this.savePost.bind(this)}
                    >
                        {this.props.info.id ? getStaticText('vc_form_update_button_label') : getStaticText('vc_form_add_button_label')}
                    </button>
                </div>
			</>);
	}

}


export default CategoryForm;